( function() {
	const locationButtons = document.querySelectorAll( '.hero--treatment__location button, .facility-filters__sort-latlong button, .find-support-large__location button, .hero__use-location button');
	const parentEleSelectors = '.hero--treatment__location, .facility-filters__sort-latlong, .find-support-large__location, .hero__use-location';

	if( !locationButtons || !locationButtons.length ) { return; }

	locationButtons.forEach( function( link ) {
		link.addEventListener( 'click', requestUserLocation );
	} );

	function requestUserLocation( e ) {
		e.preventDefault();

		if( navigator.geolocation ) {
			navigator.geolocation.getCurrentPosition( function( position ) {
				const latitude = position.coords.latitude;
				const longitude = position.coords.longitude;

				const href = e.target.dataset.href;

				let hash = href.split( '#' );
				hash = hash.length > 1 ? hash[1] : '';

				window.location = href
					+ ( href.includes( '?' ) ? '&' : '?' ) 
					+ 'lat=' + latitude 
					+ '&long=' + longitude 
					+ ( hash ? '#' + hash : '' );
			}, function() {
				geolocationError( e.target );
			} );
		} else {
			geolocationError( e.target );
		}
	}

	function geolocationError( btn ) {
		btn.closest( parentEleSelectors ).classList.add( 'error' );
	}
} )();